import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiMail, FiPhone, FiUserCheck, FiKey, FiX, FiMaximize2 } from 'react-icons/fi';
import { getUnitLabelParamsFromBool } from '../lib/Utils';

const DetailRow = ({ icon: Icon, label, value }) => (
    <div className="row">
        <span className="row-icon">
            <Icon size={15} />
        </span>
        <div className="row-text">
            <p className="row-label">{label}</p>
            <p className="row-value">{value || '-'}</p>
        </div>
    </div>
);

const DoorAssignedUserDetailsModal = ({ visible, userDetails, handleClose, handleReleaseLocker, isPodLockerType }) => {
    const { t } = useTranslation();

    if (!visible || !userDetails) return null;

    const unitLabelParams = getUnitLabelParamsFromBool(isPodLockerType, t);

    const fullName = (userDetails.full_name || '').trim();
    const [firstName = '', lastName = ''] = fullName ? [fullName.split(' ')[0], fullName.split(' ').slice(1).join(' ')] : [];
    const initials = `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase();
    const lockerLabel = [
        userDetails.locker_bank_name,
        userDetails.door_number ? `${t('label_door_number')} ${userDetails.door_number}` : null,
    ].filter(Boolean).join(' · ');

    const userAttrFields = Object.entries(userDetails.user_attrs || {}).map(([key, value]) => ({
        icon: FiUserCheck,
        label: key.replace(/\b\w/g, (char) => char.toUpperCase()),
        value,
    }));

    const detailFields = [
        { icon: FiMaximize2, label: t('label_door_size'), value: userDetails.door_size },
        { icon: FiMail, label: t('Email'), value: userDetails.email },
        { icon: FiPhone, label: t('phone_label'), value: userDetails.phone },
        ...userAttrFields,
    ];

    return (
        <div className="door-user-details-modal-overlay" id="door-user-details-modal-overlay">
            <div className="door-user-details-modal" id="door-user-details-modal">
                <div className="header">
                    <button
                        type="button"
                        className="close-button"
                        onClick={handleClose}
                        aria-label={t('button_ok')}
                    >
                        <FiX size={20} />
                    </button>
                    <p className="eyebrow">{t('lockerDetailsText', unitLabelParams)}</p>
                    <p className="locker-name">{lockerLabel || '-'}</p>
                    {userDetails.assigned_date &&
                        <span className="allocated-badge">
                            {t('label_assigned_date')}: {userDetails.assigned_date}
                        </span>
                    }
                </div>

                <div className="scrollable-content">
                    <div className="identity">
                        <div className="avatar">{initials || '-'}</div>
                        <div className="identity-text">
                            <h2 className="name">{fullName || '-'}</h2>
                        </div>
                    </div>

                    <div className="body">
                        {detailFields.map(({ icon, label, value }) => (
                            <DetailRow key={label} icon={icon} label={label} value={value} />
                        ))}
                    </div>
                </div>

                <div className="actions">
                    <button
                        type="button"
                        id="door-user-details-modal-ok-button"
                        className="button button-outline"
                        onClick={handleClose}
                    >
                        {t('button_ok')}
                    </button>
                    <button
                        type="button"
                        id="door-user-details-modal-release-button"
                        className="button button-filled"
                        onClick={handleReleaseLocker}
                    >
                        <FiKey size={16} />
                        {t('button_release_locker', unitLabelParams)}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DoorAssignedUserDetailsModal;
